import * as React from 'react';
import { onChange, validateForm } from '../../utils';

class AddComponent extends React.Component<any, any> {
    constructor(props: any) {
        super(props);
        const detail = props.detail;
        this.state = {
            id: detail ? detail.id : undefined,
            title: { name: 'title', value: detail && detail.title ? detail.title : '', error: '', isRequired: true },
            description: { name: 'description', value: detail && detail.description ? detail.description : '', error: '', isRequired: true },
        }
    }

    public render() {
        const { title, description } = this.state;
        return (
            <form onSubmit={this.onSubmit}>
                <div className="row">
                    <div className="form-group col-lg-12">
                        <input
                            type="text"
                            className={title.error.length > 0 ? "form-control is-invalid" : "form-control"}
                            placeholder="Write title here"
                            name={title.name}
                            value={title.value}
                            onChange={this.onChange}
                        />
                    </div>
                    <div className="col-lg-12 form-group">
                        <textarea
                            className={description.error.length > 0 ? "form-control is-invalid" : "form-control"}
                            rows={5}
                            placeholder="Write description here"
                            name={description.name}
                            value={description.value}
                            onChange={this.onChange}
                        />
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-3">
                        <button onClick={this.props.onCancel} type="button" className="btn btn-secondary btn-sm btn-block">Cancel</button>
                    </div>
                    <div className="col-md-3" />
                    <div className="col-md-3" />
                    <div className="col-md-3">
                        <button type="submit" className="btn btn-primary btn-sm btn-sm btn-block">Save Changes</button>
                    </div>
                </div>
            </form>
        )
    }

    private onChange = (e: any) => {
        const name = e.target.name;
        const value = e.target.value;
        onChange(this, name, value);
    }

    onSubmit = (e: any) => {
        e.preventDefault();
        if (validateForm(this)) {
            let model: any = {
                title: this.state.title.value,
                description: this.state.description.value,
            }
            if (this.state.id) {
                model.id = this.state.id;
            }
            this.props.onSubmit(model);
        }
    }

}

export default AddComponent;